import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '8px',
    width: '280px'
  },
  filterHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  titlePadding: {
    paddingTop: '24px',
    paddingBottom: '16px'
  },
  foldersHeader: {
    paddingLeft: '8px',
    fontWeight: foundations.typography.fontWeight.medium,
    fontSize: '14px',
    color: semanticColors.foreground.secondary
  },
  folderIcon: {
    fill: semanticColors.foreground.secondary,
    color: semanticColors.foreground.secondary
  },
  noSectionsView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '56px',
    '& > span': {
      marginTop: '8px'
    }
  },
  noSectionsText: {
    marginTop: '8px',
    color: semanticColors.foreground.secondary
  },
  loadingSpinner: {
    display: 'flex',
    width: '100%',
    height: '80px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  menuListContainer: {
    overflowY: 'auto',
    width: '100%'
  },
  sectionItem: {
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  sectionLabel: {
    fontWeight: foundations.typography.fontWeight.medium,
    color: semanticColors.foreground.primary
  },
  nestedList: {
    paddingLeft: '16px'
  },
  menuItem: {
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  menuItemLabel: {
    color: semanticColors.foreground.primary
  }
});
